<template>
  <div>
    <div class="mt-4">
      <h2>Bitte geben Sie Ihre Rechnungsanschrift ein</h2>

      <div>
        <div class="mt-1">
          <select v-model="campain_data.gender" placeholder="Anrede">
            <option value="">- Anrede -</option>
            <option value="Frau">Frau</option>
            <option value="Herr">Herr</option>
          </select>
        </div>
        <div class="mt-1">
          <input type="text" v-model="campain_data.company" placeholder="Firma">
        </div>
        <div class="mt-1 gap-2 flex">
          <input type="text" required v-model="campain_data.lastname" placeholder="Nachname">
          <input type="text" required v-model="campain_data.firstname" placeholder="Vorname">
        </div>
        <div class="mt-1">
        </div>
        <div class="mt-1">
          <input type="text" required v-model="campain_data.street" placeholder="Straße">
        </div>
        <div class="mt-1 grid grid-cols-4 gap-2">
          <input type="text" required v-model="campain_data.zipcode" placeholder="PLZ"
                 :class="{ 'field_error': !valid_number(campain_data.zipcode) }">
          <input class="col-span-3" required type="text" v-model="campain_data.city" placeholder="Ort">
        </div>
        <div class="mt-1">
          <select v-model="campain_data.country_id" required placeholder="Land">
            <option value="">- Land -</option>
            <option value="1">Österreich</option>
            <option value="2">Deutschland</option>
            <option value="3">Schweiz</option>
            <option value="4">Liechtenstein</option>
            <option value="5">Italien</option>
          </select>
        </div>
      </div>
      <div class="mt-1">
        <input type="email"
               required
               v-model="campain_data.email"
               placeholder="Email Adresse"
               :class="{ 'field_error': !valid_email(campain_data.email) }">
      </div>
      <div class="mt-1">
        <input type="text" required v-model="campain_data.telefon" placeholder="Telefonnummer (Format: +43 5522 36006)"
               :class="{ 'field_error': !valid_telefon(campain_data.telefon) }">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    campain_data: {
      type: Object,
      required: true
    }
  },
  methods: {
    valid_email(email) {
      if (email?.length <= 0) return true
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true
      } else {
        return false
      }
    },
    valid_number( field ) {
      if (field?.length <= 0) return true
      return /^[0-9]+$/.test(field)
    },
    valid_telefon( field ) {
      if (field?.length <= 0) return true
      return /^[0-9+ ]+$/.test(field)
    }
  }
}
</script>

<style lang="scss" scoped>
.field_error { background-color: lightcoral !important; }
.mt-1 { margin-top: 2px; }
.mt-4 { margin-top: 8px; }
.mt-10 { margin-top: 20px; }
select, option, textarea, input[type="submit"], input[type="date"], input[type="email"], input[type="text"], input[type="password"] {
  border: 1px solid #efefef;
  font-size: 13px;
  line-height: 22px;
  width: 100%;
  background-color: #efefef;
  padding: 2px 4px;
  // height: 32px !important;
  margin-bottom: 1px;
}
.inserate label {
  font-weight: 300;
}
button:disabled {
  opacity: 0.5;
}
</style>
